<template>
    <div class="profile-avatar">
        <v-avatar :color="color" :size="size" ref="avatar">
            <img v-if="src" :src="src" :alt="title">
            <span v-else class="white--text headline text-uppercase">{{title[0]}}</span>
        </v-avatar>
        <svg class="profile-avatar__bg" width="100%" height="100%" viewBox="0 0 100 100">
            <circle ref="circle" cx="50" cy="50" r="48" fill="none" :stroke="color" stroke-width="1%" style="opacity: 0" />
        </svg>
    </div>
</template>
<style scoped>
.profile-avatar {
    display: inline-flex;
    position: relative;
    z-index: 1;
}

.profile-avatar__bg {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 110%;
    height: 110%;
    z-index: -1;
    transform: translateX(-50%) translateY(-50%);
}
</style>
<script>
import gsap from "gsap"
import { DrawSVGPlugin } from "@/plugins/gsap/DrawSVGPlugin.min.js"
gsap.registerPlugin(DrawSVGPlugin)

export default {
    props: ['size', 'src', 'title', 'color'],
    mounted() {
        this.$nextTick(() => {
            // Avatar animation
            this.avatarAnimation()
        })
    },

    methods: {
        avatarAnimation() {
            let tl = gsap.timeline(),
                circle = this.$refs.circle

            gsap.set(circle, { autoAlpha: 1, drawSVG: "0% 0%" })

            tl.set(circle, { drawSVG: "0% 0%" })
                .to(circle, {
                    drawSVG: "0% 100%",
                    duration: 1.5,
                    delay: 0.5
                })
        }
    }
}
</script>